import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import DetailsForm from './DetailsForm'
import DescriptionForm from './DescriptionForm'
import LocationForm from './LocationForm'
import LanguagesForm from './LanguagesForm'
import GuruLocationsForm from './GuruLocationsForm'
import CategoryForm from './CategoryForm'
import ExpertiseForm from './ExpertiseForm'
import ServiceDescriptionForm from './ServiceDescriptionForm'
import TripsForm from './TripsForm'
import ServicesForm from './ServicesForm'
import ExamplePlanForm from './ExamplePlanForm'
import PhotosForm from './PhotosForm'
import FinishPage from './FinishPage'
import PayPal from './PayPal'

import { translate } from 'react-i18next'
import { NotificationManager } from 'react-notifications'

import CreatingComponent from '../../CreatingComponent'
import USER_QUERY from './../../../graphql/UserByID.graphql'
import CREATE_PLANNER_PROFILE_QUERY from './../../../graphql/CreatePlannerProfile.graphql'
import { Loader } from '../../UI'
import { getGuruNavSteps } from '../../../constants'
import _ from 'lodash'
import get from 'lodash/get'

class CreateGuru extends Component {
  state = {
    routes: {}
  }

  createGuruContainers = [
    {
      path: '/create-guru-profile/details',
      component: () => <DetailsForm {...this.props} validate={this.validateViewForm} />
    },
    {
      path: '/create-guru-profile/description',
      component: () => <DescriptionForm {...this.props} validate={this.validateViewForm} />
    },
    {
      path: '/create-guru-profile/location',
      component: () => <LocationForm {...this.props} validate={this.validateViewForm} />
    },
    {
      path: '/create-guru-profile/photos',
      component: () => <PhotosForm {...this.props} validate={this.validateViewForm} />
    },
    {
      path: '/create-guru-profile/languages',
      component: () => <LanguagesForm {...this.props} validate={this.validateViewForm} />
    },
    {
      path: '/create-guru-profile/guru-locations',
      component: () => <GuruLocationsForm {...this.props} validate={this.validateViewForm} />
    },
    {
      path: '/create-guru-profile/category',
      component: () => <CategoryForm {...this.props} validate={this.validateViewForm} />
    },
    {
      path: '/create-guru-profile/expertise',
      component: () => <ExpertiseForm {...this.props} validate={this.validateViewForm} />
    },
    {
      path: '/create-guru-profile/service-description',
      component: () => <ServiceDescriptionForm {...this.props} validate={this.validateViewForm} />
    },
    {
      path: '/create-guru-profile/trips',
      component: () => <TripsForm {...this.props} validate={this.validateViewForm} />
    },
    {
      path: '/create-guru-profile/services',
      component: () => <ServicesForm {...this.props} validate={this.validateViewForm} />
    },
    {
      path: '/create-guru-profile/example-plan',
      component: () => <ExamplePlanForm {...this.props} validate={this.validateViewForm} validateData={this.state.routes} />
    },
    {
      path: '/create-guru-profile/finish',
      component: () => <FinishPage {...this.props} validate={this.validateViewForm} validateData={this.state.routes} />
    },
    {
      path: '/create-guru-profile/pay-pal',
      component: () => <PayPal {...this.props} validate={this.validateViewForm} />
    }
  ]

  validateViewForm = (route, valid) => {
    this.setState({ routes: { ...this.state.routes, [route]: valid } })
  }

  checkPlannerProfile = user => {
    if (!_.get(user, 'plannerProfile', false)) {
      this.createProfile(user)
    }
  }

  createProfile = user => {
    this.props
      .createPlannerProfile({
        variables: {
          userId: user.id
        }
      })
      .then(this.props.data.refetch())
      .catch(err => {
        NotificationManager.error(err.message, 'Error', 5000)
      })
  }

  fillValidateArray = (data, toValidate = []) => {

    toValidate.push(!!_.get(data, 'user.userProfile.firstName', false))
    toValidate.push(!!_.get(data, 'user.plannerProfile.aboutMyself', false))
    toValidate.push(!!_.get(data, 'user.userProfile.location', false))
    toValidate.push(!!_.get(data, 'user.plannerProfile.photos', []).length)
    if (data.User && data.User.plannerProfile.languages) {
      toValidate.push(!!_.get(data, 'user.plannerProfile.languages', []).length)
    }
    toValidate.push(!!_.get(data, 'user.plannerProfile.locations', []).length)
    if (data.User && data.User.plannerProfile.categories) {
      toValidate.push(!!_.get(data, 'user.plannerProfile.categories', []).length)
    }
    if (data.User && data.User.plannerProfile.expertises) {
      toValidate.push(!!_.get(data, 'user.plannerProfile.expertises', []).length)
    }
    toValidate.push(!!_.get(data, 'user.plannerProfile.serviceDescription', false))
    if (data.User && data.User.plannerProfile.planOffers) {
      toValidate.push(!!_.get(data, 'user.plannerProfile.planOffers', []).length)
    }
    if (data.User && data.User.plannerProfile.serviceOffers) {
      toValidate.push(!!_.get(data, 'user.plannerProfile.serviceOffers', []).length)
    }
    toValidate.push(!!_.get(data, 'user.userProfile.payPalEmail', false))
    toValidate.push(!!_.get(data, 'user.plannerProfile.examplePlan', false))
    return toValidate
  }

  validateSteps = ({ data }) => {
    let routes = {}
    if (data.User) {
      const toValidate = this.fillValidateArray(data)
      toValidate.forEach((item, index) => {
        if (item) {
          routes = { ...routes, [`${index}`]: true }
        }
      })
      this.setState({ routes })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data.loading && !nextProps.data.loading) {
      if (!nextProps.data.user) {
        this.props.history.push('/')
      } else {
        this.checkPlannerProfile(nextProps.data.user);
        this.validateSteps(nextProps)
      }
    }
  }

  componentWillMount() {
    this.props.history.push('details')
  }

  render() {
    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    return (
      <CreatingComponent
        getNavSteps={() => getGuruNavSteps(this.props.t)}
        containers={this.createGuruContainers}
        routes={this.state.routes}
      />
    )
  }
}

const enhance = compose(
  translate('guru'),
  graphql(CREATE_PLANNER_PROFILE_QUERY, {
    name: 'createPlannerProfile'  
  }),
  graphql(USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  }),
  withRouter
)

export default enhance(CreateGuru)



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/CreateGuru.js